"use client";
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isLoginEnabled } from "@/lib/login-enabled";
export function ProtectedRoute({ children, requireDoctor = true }) {
    const { token, userInfo, isReady } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        var _a;
        if (!isReady)
            return;
        if (!token) {
            const continuation = location.pathname === "/mcp/authorize"
                ? (_a = new URLSearchParams(location.search).get("continuation")) === null || _a === void 0 ? void 0 : _a.trim()
                : "";
            if (continuation) {
                navigate(`${isLoginEnabled() ? "/login" : "/"}?continuation=${encodeURIComponent(continuation)}`, {
                    replace: true,
                });
                return;
            }
            navigate(isLoginEnabled() ? "/login" : "/", {
                replace: true,
                state: { from: `${location.pathname}${location.search}` },
            });
            return;
        }
        if (requireDoctor && userInfo && !userInfo.isDoctor) {
            navigate("/pending", { replace: true });
        }
    }, [
        isReady,
        token,
        userInfo,
        requireDoctor,
        navigate,
        location.pathname,
        location.search,
    ]);
    if (!token)
        return null;
    if (requireDoctor && userInfo && !userInfo.isDoctor)
        return null;
    return _jsx(_Fragment, { children: children });
}
